import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router-dom'
import moment from 'moment'

export default function PreviousConversations({conversations}) {
  if (!conversations || !conversations.length) return null

  return (
    <div className={styles.container}>
      <div className={styles.title}>Conv. previas</div>
      <div className={styles.content}>
        {conversations.map(conversation => (
          <div key={conversation._id}>
            <Link className={styles.date} to={`/inbox/conversations/${conversation._id}`}>
              {moment(conversation.startedAt).format('DD MMMM HH:MM')}
              <span className={styles.user}>Por {conversation.closedByName}</span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}
